import { ChangeDetectionStrategy, Component, computed, inject, signal } from '@angular/core';
import { IrisMainMenuService } from '@iris/common/services/main-menu.service';
import { IrisLogoService } from '@iris/common/services/logo.service';
import { toSignal } from '@angular/core/rxjs-interop';
import { IrisGlobalSandbox } from '@iris/common/redux/global.sandbox';
import { IRIS_APPLICATION_ALIAS } from '@iris/common/models/IrisApplication';

@Component({
  selector: 'iris-header-dropdown-menu',
  templateUrl: './header-dropdown-menu.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class IrisHeaderDropdownMenuComponent {
  private readonly menuService = inject(IrisMainMenuService);
  private readonly logoService = inject(IrisLogoService);
  private readonly globalSandbox = inject(IrisGlobalSandbox);

  readonly isApplicationMenuListOpen = signal(false);
  readonly applicationIcon = computed(() => {
    return this.globalSandbox.currentApplication()?.logo;
  });
  readonly applicationImage = computed(() => {
    return this.globalSandbox.currentApplication()?.image;
  });
  readonly brand = toSignal(this.logoService.activeBrand$, {
    initialValue: null,
  });

  private readonly applications = toSignal(this.globalSandbox.applications$, {
    initialValue: [],
  });

  readonly defaultAppRoute = computed(() => {
    const applications = this.applications();
    return applications?.length === 1 ? ['/', applications[0].applicationAlias] : null;
  });

  readonly defaultAppHasImage = computed(() => {
    const brand = this.brand();
    const alias = this.globalSandbox.appAlias();
    return IRIS_APPLICATION_ALIAS === alias && !!brand?.data;
  });

  public toggleSidenav(): void {
    void this.menuService.sidenav.toggle();
  }

  public toggleApplicationMenuList(forceState?: boolean): void {
    if(forceState !== undefined) {
      this.isApplicationMenuListOpen.set(forceState);
      return;
    }

    if(this.menuService.sidenav.opened) {
      this.toggleSidenav();

      setTimeout(()=> {
        this.isApplicationMenuListOpen.set(!this.isApplicationMenuListOpen());
      }, 300);
    } else {
      this.isApplicationMenuListOpen.set(!this.isApplicationMenuListOpen());
    }
  }
}
